import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";

import { config } from "../../../../../config/index";

import { SessionStorageService } from "../../services/session-storage.service";


@Component({
	selector: 'menubar',
	template: require('./menubar.component.html'),
	styles: [require('./menubar.component.less')],
	preserveWhitespaces: true
})

export class MenubarComponent {

	hideMenu: boolean;
	menuListTitles: any = [];
	package = config.package;
	subscription: any;
	private _menuList = config.menu_list;
	currentUrl: string;

	constructor(
		private _router: Router,
		private _sessionStorageService: SessionStorageService,
		@Inject('utilService') private utilService: any
	) {
		this.utilService.hideHeaderNavDropDownNotSubscribed.subscribe(this.hideDropdownHeaderNav);
	}

	hideDropdownHeaderNav = (data: any) => {
		if (data.hide) {
			let menuListTitlesNotSubscribed: any = [];
			this.menuListTitles.forEach((element: any) => {
				if (element.title === 'Dashboard' || element.title === 'Logout') {
					menuListTitlesNotSubscribed.push(element);
				}
			});
			this.menuListTitles = menuListTitlesNotSubscribed;
		}
	}

	/**
	 * Function for navigating to Dashboard on menu selection
	 */
	dashboardRouting() {
		this._router.navigate(['home/dashboard']);
	}

	/**
	 * Function for navigating to Practice List Component on menu selection
	 */
	userManagementRouting() {
		this._router.navigate(['/practice-list']);
	}

	/**
	 * Function to hide Menubar
	 */
	hideMenuBar() {
		this.hideMenu = !this.hideMenu;
		this.utilService.hideHeaderNavDropDownNotSubscribed.next({ opened: !this.hideMenu });
	}

	/**
	 * Function to navigate to path of selected menu.
	 * @param {any} data contains router path.
	 */
	loadPath(data: any) {
		// for lazy loading
		switch (data) {
			case 'case-study-list':
				this._router.navigate(['gallery/case-study-list']);
				break;
			case 'user-list':
				this._router.navigate(['user/user-list']);
				break;
			case 'practice-list':
				this._router.navigate(['practice/practice-list']);
				break;
			case 'enterprise-list':
				this._router.navigate(['enterprise/enterprise-list']);
				break;
			case 'patient-file-list':
				this._router.navigate(['patient/patient-file-list']);
				break;
			case 'dashboard-display-report':
				this._router.navigate(['pa-settings/dashboard-display-report']);
				break;
			case 'ct-category':
				this._router.navigate(['ct-settings/ct-category']);
				break;
			case 'dashboard':
				this._router.navigate(['home/dashboard']);
				break;
			case 'reports':
				this._router.navigate(['reports/all']);
				break;
			case 'doctor-referral-list':
				this._router.navigate(['referral/doctor-referral-list']);
				break;
			case 'patient-referral-list':
				this._router.navigate(['referral/patient-referral-list']);
				break;
			case 'email-template':
				this._router.navigate(['pa-settings/email-template']);
				break;
			case 'add-case-study':
				this._sessionStorageService.saveItem('add-edit-case-study', 'add').then(
					() => this._router.navigate(['gallery/add-case-study'])
				);
				break;

			default:
				this._router.navigate([data]);
				break;
		}
	}

	/**
	 * Function to load menu list in menu bar.
	 * @param  {any} data contains role based menu list.
	 */
	loadMenuList(data: any) {
		this.menuListTitles = data.menuList;
	}

	// read package
	readPackage() {
		this._sessionStorageService.readItem(this.package).then((data: any) => {
			this.subscription = data.package;
		});
	}

	ngOnInit() {
		this.hideMenu = true;
		this._sessionStorageService.readItem(this._menuList).then(data => this.loadMenuList(data));
		this.readPackage();
		this.currentUrl = window.location.pathname;
	}
}
